import { render } from "./Spinner.vue?vue&type=template&id=4b14a072&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=4b14a072&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b14a072"]])

export default __exports__